import React, { useState } from 'react';
import { ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { checkoutUrl, images } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
import { OfferCountdown } from './OfferCountdown';
export function PurchaseSection() {
  const [isGuaranteeOpen, setIsGuaranteeOpen] = useState(false);
  return <section id="buy" className="border-y border-cream-300 bg-white px-6 py-12" data-id="element-67" data-mp="2w2v4k8kp9bo1">
      <img src={images.heroBox} alt="Little Engineer Megakit box with 120 projects to build, experiment and create with materials you already have at home" className="mx-auto w-full max-w-[420px]" loading="lazy" data-id="element-68" data-mp="3a2cuwsdn8wzi" />

      <p className="mt-8 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-69" data-mp="3jsz2q0f4cj7n">
        +3,369 downloads
      </p>
      <h2 className="mt-2.5 font-display text-[30px] font-semibold leading-[1.2] tracking-[-0.02em] text-ink-900" data-id="element-70" data-mp="3suf5pn3ltj1u">
        Little Engineer Mega Kit
      </h2>

      <div className="mt-5 flex flex-wrap items-baseline gap-x-3 gap-y-2" data-id="element-71" data-mp="3ouendrddwnpi">
        <span className="font-display text-[28px] font-semibold tracking-[-0.02em] text-ink-900" data-id="element-72" data-mp="y6wq7scdtsbv">
          $19.99
        </span>
        <span className="text-[16px] text-ink-500 line-through" data-id="element-73" data-mp="127qeimtql95a">$40.00 USD</span>
        <span className="rounded-full bg-forest-500/10 px-3 py-1 text-[13px] font-semibold text-forest-600" data-id="element-74" data-mp="175rugyvv8scj">
          −50% OFF · only 20 spots
        </span>
      </div>

      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: 'Little Engineer Mega Kit',
      value: 19.99,
      currency: 'USD'
    })} className="mt-7 block w-full rounded-xl bg-grass-500 px-6 py-4 text-center font-display text-[17px] font-semibold tracking-[0.02em] text-white transition-colors hover:bg-grass-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-grass-500/30" data-id="element-75" data-mp="1h5it9crgltif">
        Add to cart
      </a>

      <p className="mt-3 flex items-center justify-center gap-2 text-[13.5px] text-ink-500" data-id="element-76" data-mp="1zt4b6sfci5xx">
        <ShieldCheckIcon className="h-4 w-4 text-forest-500" aria-hidden="true" data-id="element-77" data-mp="24s7fubreya5d" />
        Instant access by email · secure payment
      </p>
      <p className="mt-2 text-center text-[12.5px] text-ink-500" data-id="element-78" data-mp="1a7lbsiy5yddz">
        100% Digital Product — No physical item will be shipped.
      </p>

      <div className="mt-9" data-id="element-79" data-mp="1oxiskdtrk0t5">
        <OfferCountdown data-id="element-80" data-mp="1oxsnmfto0y5p" />
      </div>

      <div className="mt-6 border-t border-cream-300 pt-2" data-id="element-81" data-mp="1k4zdtdjcazmr">
        <button type="button" onClick={() => setIsGuaranteeOpen(open => !open)} aria-expanded={isGuaranteeOpen} className="flex w-full items-center gap-3 py-4 text-left" data-id="element-82" data-mp="1k3eoc2bvu6vr">
          <span className="flex-1 text-[16px] font-medium text-ink-900" data-id="element-83" data-mp="1sxb511ma2r3s">
            Hands-On Guarantee, 7 days
          </span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-500 transition-transform ${isGuaranteeOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-84" data-mp="22vqy3a4v8afx" />
        </button>
        {isGuaranteeOpen ? <p className="pb-4 pr-2 text-[15.5px] leading-[1.65] text-ink-500" data-id="element-85" data-mp="diwyfzxe7eaw">
            Try the projects with your child for 7 days. If it is not what your family needed, write
            to us and we refund every cent — you keep the bonuses.
          </p> : null}
      </div>
    </section>;
}